import { Slide } from '@/components/core/Slide';
import { ImageCarousel } from '@/components/visualizers/ImageCarousel';
import audioFile from './24-masters-carousel.mp3';

const transcript = `
  Ik denk dat ik genoeg weet om aan de slag te gaan...

  Ik zal de productie in gang zetten en me even daarop concentreren. Is dit een goed moment om de zaal te 
  vertellen over Sofie van der Sterren en hoe je bent begonnen met synthografie? Ik zal het publiek ook op de 
  achtergrond andere stijlen van synthografie laten zien, zodat ze weten dat met synthografie elke visuele stijl 
  binnen handbereik ligt.
`;

const images = [
  'https://cdn.midjourney.com/1f27a6da-4356-4f46-a002-92e8b0df798c/0_2.png',
  'https://cdn.midjourney.com/23c438cf-7a6c-4ea1-a387-9a82141413f2/0_2.png',
  'https://cdn.midjourney.com/2c0c9e8c-7563-43b2-8c08-e5df8ca1b62e/0_1.png',
  'https://cdn.midjourney.com/da6e7430-e0fd-4b3a-99e1-3f6b93b93605/0_0.png',
  'https://cdn.midjourney.com/df715cfb-79a9-4743-ae16-f9140e8a8877/0_3.png',
  'https://cdn.midjourney.com/7d68250b-75ab-457e-bbab-7252bc69ad28/0_3.png',
  'https://cdn.midjourney.com/cecd26a1-8edd-49ed-96ae-930e3b09d20c/0_0.png',
  'https://cdn.midjourney.com/073f4a74-8f61-4fe9-bac7-80b255c89693/0_3.png',
  'https://cdn.midjourney.com/622655d0-dff5-46fe-bc2e-e34fb73f1f2a/0_0.png',
  'https://cdn.midjourney.com/92350469-569e-46cd-aa5b-9d2bc14551c2/0_3.png',
  'https://cdn.midjourney.com/1f27a6da-4356-4f46-a002-92e8b0df798c/0_0.png',
  'https://cdn.midjourney.com/f659d007-a0c0-4297-b150-128c6af2b04d/0_0.png',
  'https://cdn.midjourney.com/9ee1956f-adc8-4cf1-81a8-0707cc6c4ad5/0_1.png',
  'https://cdn.midjourney.com/8544e155-adb6-4de7-b9ac-5dbb960cc60b/0_0.png',
  'https://cdn.midjourney.com/203a54fb-8d9c-4afe-9730-eaf57940edf9/0_3.png',
  'https://cdn.midjourney.com/c4878be0-e79d-4f3f-9953-f7db3050c8ad/0_0.png',
  'https://cdn.midjourney.com/cdfe6842-7452-486d-9b0e-02124051ff5a/0_3.png',
  'https://cdn.midjourney.com/ee5bc096-c59a-4179-8f19-59ea9b7d211b/0_3.png',
  'https://cdn.midjourney.com/8ff69ed4-6cbd-40ee-befa-a5815593cadc/0_3.png',
  'https://cdn.midjourney.com/408f4f9e-b12f-4b93-bee8-bf696858bbb7/0_0.png',
  'https://cdn.midjourney.com/eeed89f3-6b68-4d7a-863f-c35a6e71826a/0_0.png',
  'https://cdn.midjourney.com/4f823d29-9a23-40e4-a228-f0502f1f6b35/0_0.png',
  'https://cdn.midjourney.com/ac470de7-337d-4bdb-9460-46e8b2bd8204/0_3.png',
  'https://cdn.midjourney.com/dad21033-376b-4215-a792-6ddb727063fb/0_0.png',
  'https://cdn.midjourney.com/45814b2a-26ea-4bf4-a208-dbae1a44d032/0_1.png',
  'https://cdn.midjourney.com/aab44b76-3cec-4ce1-8814-95b3578b8f90/0_1.png',
  'https://cdn.midjourney.com/12a462fb-3275-42ff-9015-9d8f55723c3e/0_0.png',
  'https://cdn.midjourney.com/7e3822b2-0ca3-49cb-8964-115cee1ac387/0_1.png',
  'https://cdn.midjourney.com/e6c5027b-39a2-41f3-994f-de1b19303727/0_2.png',
  'https://cdn.midjourney.com/ac470de7-337d-4bdb-9460-46e8b2bd8204/0_0.png',
  'https://cdn.midjourney.com/df715cfb-79a9-4743-ae16-f9140e8a8877/0_0.png',
  'https://cdn.midjourney.com/6c25d86a-538d-4bc3-805c-2dec248e846d/0_1.png',
  'https://cdn.midjourney.com/6c25d86a-538d-4bc3-805c-2dec248e846d/0_3.png',
  'https://cdn.midjourney.com/005d57a9-500c-4e44-9159-e286384b7edf/0_3.png',
  'https://cdn.midjourney.com/6a54f4f6-b33a-455e-b17f-5f7551e22e82/0_0.png',
  'https://cdn.midjourney.com/aa88ae75-41ac-40aa-a9de-67b51b0cf4ca/0_0.png',
  'https://cdn.midjourney.com/d5dd874b-49ef-4ada-ba2b-0848f0f41eb0/0_2.png',
  'https://cdn.midjourney.com/fe136b3b-5a0c-4533-bdd5-9f1049a18f79/0_1.png',
  'https://cdn.midjourney.com/3772556f-bd06-4371-9994-611aa5fd12a7/0_0.png',
  'https://cdn.midjourney.com/6a6d5eb3-f758-40cd-923e-afb12891b820/0_2.png',
  'https://cdn.midjourney.com/8ac5e69d-26a6-4751-b26a-d6740f45cd2f/0_0.png',
  'https://cdn.midjourney.com/31bc83b3-2b3f-441a-bc30-5756b97dfc40/0_1.png',
  'https://cdn.midjourney.com/89d50ce1-ae20-42f5-9f6d-9c6eb5f7ae38/0_3.png',
  'https://cdn.midjourney.com/55f4bebf-4292-481d-a59f-4183b1bb4bab/0_3.png',
  'https://cdn.midjourney.com/e85f95c8-33f8-4b2a-bb61-dcb92480deb6/0_2.png',
  'https://cdn.midjourney.com/750be706-562c-484a-ad18-10ca28a82062/0_1.png',
  'https://cdn.midjourney.com/6fce5c8a-0249-42e5-a241-e10782a55834/0_2.png',
  'https://cdn.midjourney.com/596f6ead-e70b-4424-86e6-4ae3e61fc9e5/0_2.png',
  'https://cdn.midjourney.com/6c360a12-051c-4e32-8584-faa36d207fc4/0_3.png',
  'https://cdn.midjourney.com/8748b353-bb7e-4096-b7d0-15629a903a19/0_0.png',
  'https://cdn.midjourney.com/591ed2f5-5e52-4601-bec6-87835cd7e8d4/0_0.png',
  'https://cdn.midjourney.com/a5ac4a46-3324-4bc6-9bbc-5e470d953187/0_3.png',
  'https://cdn.midjourney.com/8144cde8-9a7f-43bc-9b74-c88df7c34742/0_3.png',
  'https://cdn.midjourney.com/a82759d1-f094-40da-b8ff-ae09111a5d37/0_2.png',
];

export const slide = () => {
  return (
    <Slide notes={transcript} audio={audioFile} transition="fade" visualizer="hidden">
      <ImageCarousel images={images} speed={0.003} />
    </Slide>
  );
};
